import { render } from "./FreeList.vue?vue&type=template&id=65da6e13&scoped=true"
import script from "./FreeList.vue?vue&type=script&lang=js"
export * from "./FreeList.vue?vue&type=script&lang=js"

import "./FreeList.vue?vue&type=style&index=0&id=65da6e13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65da6e13"]])

export default __exports__